var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/global.28ab2604b3e01ee6a5f79b69829afa28.svg#pin';
                    var viewUrl = 'svg/global.28ab2604b3e01ee6a5f79b69829afa28.svg#view-pin';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 24 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };